import { SET_EXPERIMENTS } from '../actions/set-experiments';

export default function experiments(state = {}, action) {
  switch (action.type) {
    case SET_EXPERIMENTS:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/experiments.js